module.exports = __webpack_public_path__ + "img/90-Staufereiche Mocca Palissandre.jpg";